import { SelectV2, SelectV2Option } from '@cimplico/components';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { WorksheetSchemaListItem } from '../../../../../types/custom-worksheet-v2';
import { setRenamingPropertyId } from '../../store/slice';

type ListItemSelectProps = {
    title: string;
    value?: string;
    listItems: WorksheetSchemaListItem[];
    onChange: (listItem?: string) => void;
};

function ListItemSelect({ title, value, listItems, onChange }: ListItemSelectProps): JSX.Element {
    const dispatch = useDispatch();

    const [selected, setSelected] = useState<SelectV2Option[]>([]);
    const [search, setSearch] = useState('');

    function handleListItemChange(options: SelectV2Option[]): void {
        // On list item value change, clear editing state
        dispatch(setRenamingPropertyId(undefined));

        if (options.length === 0) {
            onChange(undefined);
            return;
        }
        onChange(listItems.filter((item) => options.find((opt) => opt.value === item.id))[0].id);
    }

    useEffect(() => {
        setSelected(listItems.filter((item) => item.id === value).map((i) => ({ value: i.id, label: i.name })));
    }, [value, listItems]);

    return (
        <div className="py-4 w-[300px]">
            <SelectV2
                title={title}
                keepSelectedOptions
                allowOverflow
                size="small"
                placeholder="Select an item..."
                value={selected}
                onSearch={setSearch}
                onChange={handleListItemChange}
                options={listItems
                    .filter((opt) => opt.name.toLowerCase().includes(search.toLowerCase()))
                    .map((option) => {
                        return { label: option.name, value: option.id };
                    })}
            />
        </div>
    );
}
export default ListItemSelect;
